(function () {
  'use strict';
  var carouselId = 'judge_me_reviews_featured_carousel_eNKPyj';
  var selector = '.shopify-app-block[id$="__' + carouselId + '"]';
  var resizeScheduled = false;

  function visibleAccordionColumn() {
    var columns = document.querySelectorAll('.left-side-blocks.for-desktop, .left-side-blocks.for-mobile');
    for (var i = 0; i < columns.length; i++) {
      if (columns[i].getClientRects().length && window.getComputedStyle(columns[i]).display !== 'none') {
        return columns[i];
      }
    }
    return null;
  }

  function applicationAccordion(column) {
    var accordions = column.querySelectorAll('.accordion');
    for (var i = 0; i < accordions.length; i++) {
      var heading = accordions[i].querySelector('.accordion__label h3, .accordion__label h2');
      if (heading && heading.textContent.trim() === 'Anwendung') {
        return accordions[i];
      }
    }
    return null;
  }

  function relocateCarousel() {
    var carousel = document.querySelector(selector);
    var column = visibleAccordionColumn();
    if (!carousel || !column) return;
    var anchor = applicationAccordion(column);
    if (!anchor) return;
    if (carousel.parentNode !== anchor.parentNode || carousel.nextElementSibling !== anchor) {
      anchor.parentNode.insertBefore(carousel, anchor);
    }
  }

  function onResize() {
    if (resizeScheduled) return;
    resizeScheduled = true;
    window.requestAnimationFrame(function () {
      resizeScheduled = false;
      relocateCarousel();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', relocateCarousel);
  } else {
    relocateCarousel();
  }
  window.addEventListener('load', relocateCarousel);
  window.addEventListener('resize', onResize);
  document.addEventListener('shopify:section:load', relocateCarousel);
})();
